import {
  Alert,
  Button,
  Code,
  CopyButton,
  Group,
  Modal,
  Stack,
  Text,
} from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

// Модалка «токен раннера показан один раз» (ADR-0073) — общая для
// регистрации и перевыпуска: родитель (`RunnersSection`) кладёт
// полученный токен в своё состояние и передаёт сюда, а по «Готово»
// стирает его из состояния И из мутации, которая его принесла
// (`onClose` → `setShownToken(null)` + `registerRunner.reset()`/
// `reissueToken.reset()`). Токен не попадает ни в query cache, ни в
// localStorage/sessionStorage; `token` здесь рендерится ТОЛЬКО пока он
// не `null` — после закрытия модалки токена больше нет в DOM,
// независимо от того, как долго Mantine держит `<Modal>` смонтированным
// во время closing-анимации.
//
// Закрывается ТОЛЬКО кнопкой «Готово»: `closeOnClickOutside={false}`,
// `closeOnEscape={false}`, без крестика (`withCloseButton={false}`) —
// `onClose` безвозвратно стирает токен из состояния родителя
// (единственный способ его увидеть — перевыпуск), случайный клик мимо
// или Esc не должны терять только что выданное значение.
export function RunnerTokenModal({
  token,
  onClose,
}: {
  readonly token: string | null;
  readonly onClose: () => void;
}): ReactElement {
  const { t } = useTranslation();

  return (
    <Modal
      opened={token !== null}
      onClose={onClose}
      title={t("runners.tokenModal.title")}
      centered
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={false}
    >
      {token !== null ? (
        <Stack gap="md">
          <Alert color="yellow" title={t("runners.tokenModal.warningTitle")}>
            {t("runners.tokenModal.warningBody")}
          </Alert>
          <Group gap="sm" wrap="nowrap">
            <Code style={{ flex: 1, wordBreak: "break-all" }}>{token}</Code>
            <CopyButton value={token}>
              {({ copied, copy }) => (
                <Button size="xs" variant="default" onClick={copy}>
                  {copied
                    ? t("runners.tokenModal.copied")
                    : t("runners.tokenModal.copy")}
                </Button>
              )}
            </CopyButton>
          </Group>
          <Text size="sm" c="dimmed">
            {t("runners.tokenModal.envHint")}
          </Text>
          <Group justify="flex-end">
            <Button onClick={onClose}>{t("runners.tokenModal.done")}</Button>
          </Group>
        </Stack>
      ) : null}
    </Modal>
  );
}
